

function initMap() {
  var $ = jQuery;

  $(function() {
    // Initialize Map
    var map = new google.maps.Map(document.getElementById('map'), {
      center: { lat: 39.8282, lng: -98.5795 },
      zoom: 4,
      scrollwheel: false
    });
    var baseDirectionsLink = 'https://maps.google.com?daddr=';

    var currCenter = map.getCenter();

    var locationTemplate = _.template('<h1><%= name %></h1><p><%= address %></p><a href="<%= gMapsLink %>" target="_blank">Get Directions</a>');
    var stateNameTemplate = _.template('<h1><%= state %></h1>');
    // Create model and collection for locations
    var LocationModel = Backbone.Model.extend({
      defaults: {
        name: '',
        position: { lat: 0, lng: 0 },
        address: '',
        gMapsLink: '',
        selected: false
      },
      parse: function(data) {
        data.position = { lat: data.lat, lng: data.lng };
        data.gMapsLink = baseDirectionsLink + encodeURIComponent(data.address);
        return data;
      }
    });

    var LocationCollection = Backbone.Collection.extend({
      url: BASE_DIR + '/lukes.json',
      model: LocationModel
    });

    var locationCollection = new LocationCollection();
    locationCollection.fetch({ reset: true });

    var LocationItem = Backbone.View.extend({
      tagName: 'div',
      className: 'location',
      template: locationTemplate,
      events: {
        'click': 'select'
      },
      initialize: function(options) {
        this.model = options.model;
      },
      render: function() {
        this.$el.append( this.template(this.model.toJSON()) );
        return this;
      }
    });

    var LocationItemWithMap = LocationItem.extend({
      events: {
        'click': 'select'
      },
      initialize: function(options) {
        this.model = options.model;
        this.map = options.map;
        this.marker = new google.maps.Marker({
          position: this.model.get('position'),
          map: this.map,
          title: this.model.get('name'),
          icon: {
            url: BASE_DIR + '/dist/images/lukes-icon.png',
            size: new google.maps.Size(35,25),
            origin: new google.maps.Point(0,0),
            anchor: new google.maps.Point(18,25)
          }
        });
        this.infoWindow = new google.maps.InfoWindow({
          content: this.template( this.model.toJSON() )
        });
        this.marker.addListener('click', this.select.bind(this));
        this.model.on('change:selected', this.handleSelect.bind(this));
      },
      scrollTo: function() {
        var $container = this.$el.parent();
        var top = this.$el.position().top;
        if (top > $container.height() || top < 0) {
          $container.animate({ scrollTop: $container.scrollTop() + top }, 1000);
        }
      },
      handleSelect: function(model) {
        if (model.get('selected')) {
          this.$el.addClass('location--selected');
          this.openInfo();
          if (map.getZoom() < 12) {
            map.setZoom(12);
          }
          map.setCenter(this.model.get('position'));
          this.scrollTo();
        } else {
          this.closeInfo();
          this.$el.removeClass('location--selected');
        }
      },
      openInfo: function() {
        this.infoWindow.open(map, this.marker);
      },
      closeInfo: function() {
        this.infoWindow.close();
      },
      select: function() {
        this.model.collection.forEach(function(model) {
          model.set({ selected: false });
        });
        this.model.set({ selected: true });
      }
    });

    var LocationList = Backbone.View.extend({
      initialize: function() {
        this.listenTo(locationCollection, 'reset', this.render.bind(this));
      },
      render: function() {
        _.forEach(locationCollection.groupBy('state'), function(stateArray, stateName) {
          this.$el.append( stateNameTemplate({ state: stateName }) );
          _.forEach(stateArray, function(model) {
            this.$el.append( new LocationItem({ model: model, parent: this }).render().$el );
          }.bind(this));
        }.bind(this));
        return this;
      }
    });

    var LocationListMap = LocationList.extend({
      initialize: function(options) {
        this.map = options.map;
        this.listenTo(locationCollection, 'reset', this.render.bind(this));
      },
      render: function() {
        _.forEach(locationCollection.groupBy('state'), function(stateArray, stateName) {
          this.$el.append( stateNameTemplate({ state: stateName }) );
          _.forEach(stateArray, function(model) {
            this.$el.append( new LocationItemWithMap({ model: model, parent: this, map: this.map }).render().$el );
          }.bind(this));
        }.bind(this));
        return this;
      }
    });

    new LocationListMap({ el: '.locations', map: map });
    new LocationList({ el: '.locations-list' });

    var locations = [];

    function generateLocations(locations) {
      var locationDiv = $('.locations');
      locations = _.map(locations, function(location) {
        return new Location({ name: location.name, position: { lat: location.lat, lng: location.lng }, address: location.address }, map);
      });
      _.forEach(locations, function(location) {
        locationDiv.append( location.link );
      });
    }

    function onResize() {
      var navHeight = $('.nav-primary').height();
      $('.map-container').height(window.innerHeight - navHeight);
    }
    onResize();

    $(window).on('resize', onResize);
  });
}
